"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const debug = debug_1.default('command-queue');
class CommandQueue {
    constructor(debugName, errorReporting) {
        this.debugName = debugName;
        this.errorReporting = errorReporting;
    }
    start() {
        this.commandSubject = new rxjs_1.Subject();
        this.observable = this.commandSubject.pipe(operators_1.observeOn(rxjs_1.queueScheduler), operators_1.concatMap(async (command) => {
            try {
                await this.executeCommand(command);
            }
            catch (err) {
                this.errorReporting.sendNonFatalException(err, `Error executing command in '${this.debugName}', skipped.`);
            }
        }));
        // used for waiting the queue to finish
        this.queueFinishedPromise = new Promise((resolve) => {
            this.queueFinishedResolve = resolve;
        });
        this.subscription = this.observable.subscribe({
            error: (err) => {
                this.errorReporting.sendFatalException(err, `Unrecoverable error while executing command in '${this.debugName}'.`);
                throw err;
            },
            complete: () => {
                if (!this.queueFinishedResolve) {
                    throw new Error('coding error: queueFinishedResolve not set');
                }
                debug('subscription completed');
                this.queueFinishedResolve();
            }
        });
    }
    async executeCommand(command) {
        debug(`executing '${command.debugName}' command in '${this.debugName}'`);
        // TODO: implement cancellation
        await command.handler({ cancel: false });
        debug(`command executed '${command.debugName}' command in '${this.debugName}'`);
    }
    async stop() {
        if (!this.subscription || !this.commandSubject) {
            throw new Error('Coding error: start has not called');
        }
        debug(`stopping command queue '${this.debugName}'`);
        this.commandSubject.complete();
        debug(`waiting to command queue '${this.debugName}' to stop`);
        await this.queueFinishedPromise;
        debug(`command queue '${this.debugName}' stopped`);
        this.subscription.unsubscribe();
        debug(`command queue '${this.debugName}' unsubscribed`);
        this.commandSubject = undefined;
    }
    queue(debugName, command) {
        if (!this.commandSubject) {
            throw new Error('Coding error: start has not called');
        }
        this.commandSubject.next({ debugName, handler: command });
    }
    queueAndWait(debugName, command) {
        debug('queueAndWait', debugName, command);
        return new Promise((resolve, reject) => {
            const delegate = async (cancelToken) => {
                try {
                    const result = await command(cancelToken);
                    debug('queueAndWait resolve', debugName, result);
                    resolve(result);
                    return result;
                }
                catch (error) {
                    debug('queueAndWait reject', debugName, error);
                    reject(error);
                    throw error;
                }
            };
            // queue the delegate for execution
            this.queue(debugName, delegate);
        });
    }
}
exports.CommandQueue = CommandQueue;
//# sourceMappingURL=command-queue.js.map